const PREQUAL_FAILURE_CODE_LABELS: Record<string, string> = {
  CHARGEOFF: "Open or prior chargeoff or collection on file",
  COMP_DEBT: "Insufficient comparable debt history",
  EQUIPMENT_YEAR: "Equipment year outside program requirements",
  EQUIPMENT_MILEAGE: "Equipment mileage exceeds program limit",
  FLEET_SIZE: "Fleet size does not meet program minimum",
  STATE_EXCLUDED: "Not available in applicant's state",
  YEARS_IN_BUSINESS: "Time in business does not meet program minimum",
  INDUSTRY_EQUIPMENT_COMBO: "Industry and equipment combination not eligible",
  PREQUAL_GATE: "Additional qualification questions required",
};

/**
 * Human-readable failure line for portal. Internal roles may include the raw code in parentheses.
 */
export function formatPrequalFailureForDisplay(
  code: string | null | undefined,
  reason: string | null | undefined,
  includeInternalCode: boolean
): string {
  const c = (code ?? "").trim();
  const r = (reason ?? "").trim();
  const mapped = c ? PREQUAL_FAILURE_CODE_LABELS[c] : undefined;
  if (mapped) {
    return includeInternalCode ? `${mapped} (${c})` : mapped;
  }
  const fallback = r || c || "—";
  return includeInternalCode && c ? `${fallback} (${c})` : fallback;
}
